import { render, staticRenderFns } from "./BreakingTechniqueAdmin.vue?vue&type=template&id=bd789674&scoped=true&"
import script from "./BreakingTechniqueAdmin.vue?vue&type=script&lang=js&"
export * from "./BreakingTechniqueAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd789674",
  null
  
)

export default component.exports